<template>
    <div class="similar-text">
        <div class="edit-textarea">
            <p class="edit-title">{{ editTitle }}</p>
            <textarea class="textarea scroll-tracker" :placeholder="placeHolder" ref="textInput"></textarea>
            <div class="edit-textarea-btn">
                <RoundButton class="add-similar-btn" :text="addSimilarLabel" @btnClick="addSimilarClick" />
            </div>
        </div>
        <ReferenceRecSimilars
            class="reference-rec-similars"
            v-show="false"
            @selectReferenceSimilar="selectReferenceSimilar"
            :referenceSimilars="referenceSimilars"
        ></ReferenceRecSimilars>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import ReferenceRecSimilars from "./ReferenceRecSimilars";
import { arrayDeduplicate } from "@/views/zhiji/js/common/util.js";

export default {
    name: "SimilarText",
    computed: {
        placeHolder() {
            return this.$t("zhiji.knowlege.quesEditModal.editSimilarTip");
        },
        addSimilarLabel() {
            return this.$t("zhiji.common.add");
        },
        editTitle() {
            return this.$t("zhiji.knowlege.quesEditModal.editSimilar");
        },
        isShowReferenceSimilars() {
            return this.getStorePorp("questionInfo").questionId !== "" ? false : true;
        },
        referenceSimilars() {
            return this.getStorePorp("referenceSimilars");
        }
    },
    components: {
        RoundButton,
        ReferenceRecSimilars
    },
    methods: {
        addSimilarClick() {
            let text = this.$refs.textInput.value;
            let result = text.split("\n");

            result =
                result.length > 0 &&
                result.filter(item => {
                    return this.zhiji.strTrim(item) && item.length > 0;
                });

            result.length > 0 && this.$emit("similarAddClick", arrayDeduplicate(result));

            this.$refs.textInput.value = "";
        },
        selectReferenceSimilar(data) {
            let inputValue = this.$refs.textInput.value;
            let curValue = inputValue.length > 0 ? inputValue + "\n" + data.value : data.value;
            this.$refs.textInput.value = curValue;
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        }
    }
};
</script>

<style lang="scss" scoped>
.similar-text {
    display: flex;
    flex-direction: row;
    padding: 24px;
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    max-height: 330px;
    flex: 1;

    .edit-title {
        margin-bottom: 8px;
    }

    .textarea {
        padding: 10px;
        margin-right: 16px;
        width: 498px;
        height: 90%;
        border: 1px solid #d8e4f0;
        resize: none;
        box-sizing: border-box;
        background: #fafbfd;
        border-radius: 4px;
    }

    .edit-textarea-btn {
        text-align: right;
        float: right;
    }
    .reference-rec-similars {
        margin-top: 27px;
    }
}
</style>
